import { renderSlot as _renderSlot, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "ButtonHover-text" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode("Label button")
const _hoisted_3 = { class: "ButtonHover-hover" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode("Label button")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.type), {
    to: _ctx.to,
    for: this.for,
    class: "ButtonHover"
  }, {
    default: _withCtx(() => [
      _createElementVNode("span", _hoisted_1, [
        _renderSlot(_ctx.$slots, "default", {}, () => [
          _hoisted_2
        ])
      ]),
      _createElementVNode("span", _hoisted_3, [
        _renderSlot(_ctx.$slots, "default", {}, () => [
          _hoisted_4
        ])
      ])
    ]),
    _: 3
  }, 8, ["to", "for"]))
}